import { assign, get, partial } from 'lodash';
import axios, { AxiosRequestConfig } from 'axios';

const API_URL = process.env.REACT_APP_API_TARGET;
const HEADERS = {
  'Content-Type': 'application/json',
};

const TOKEN_STORAGE_KEY = 'fashionnova_token_storage';

type RequestType = 'GET' | 'PUT' | 'PATCH' | 'POST' | 'DELETE';

export class HttpError extends Error {
  status?: number;
}

const request = (
  type: RequestType,
  endpoint: string,
  options: AxiosRequestConfig = {},
) => {
  const headers = assign(HEADERS, {
    'X-Auth-Token': localStorage.getItem(TOKEN_STORAGE_KEY),
  });
  console.info('Making request: ', type, endpoint);

  const config = assign(
    {},
    {
      url: API_URL + endpoint,
      method: type,
      headers,
      responseType: 'json',
      withCredentials: true,
    },
    options,
  );

  return axios(config)
    .then(
      (response) =>
        new Promise((resolve) => {
          resolve(response.data);
        }),
    )
    .catch((error) => {
      const msg =
        get(error, 'response.data.errors') ||
        get(error, 'response.data.message') ||
        get(error, 'statusText');
      let err: HttpError;
      if (typeof msg === 'object' && msg !== null) {
        err = new HttpError(JSON.stringify(msg));
      } else {
        err = new HttpError(msg);
      }
      err.status = get(error, 'response.status');
      return Promise.reject(err);
    });
};

const FETCH_TYPES = ['get', 'put', 'patch', 'post', 'delete'];

type ApiFunction = (
  endpoint: string,
  options?: AxiosRequestConfig,
) => Promise<any>;

interface ApiFunctions {
  get: ApiFunction;
  put: ApiFunction;
  patch: ApiFunction;
  post: ApiFunction;
  delete: ApiFunction;
}

function assertRequestType(type: string): RequestType {
  const validTypes: RequestType[] = ['GET', 'PUT', 'PATCH', 'POST', 'DELETE'];
  if (!validTypes.includes(type as RequestType)) {
    throw new Error(`Invalid request type: ${type}`);
  }
  return type as RequestType;
}

export default FETCH_TYPES.reduce<ApiFunctions>(
  (exp, type) =>
    assign(exp, {
      [type]: partial(request, assertRequestType(type.toUpperCase())),
    }),
  {} as ApiFunctions,
);
